import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEye } from "@fortawesome/free-solid-svg-icons";

type Props = {
  row: any;
  onView: (r: any) => void
  onDownload: (row: any) => void
};

const ActionsCell: React.FC<Props> = ({ row, onView, onDownload }) => (
  <motion.div whileHover={{ scale: 1.05 }} className="flex space-x-2">
    <button
      onClick={() => onView(row._originalData)}
      className="px-3 py-1.5 bg-blue-50 hover:bg-blue-100 dark:bg-blue-900/30 dark:hover:bg-blue-800/40 text-blue-700 dark:text-blue-400 rounded-lg transition-colors duration-200 flex items-center"
    >
      <FontAwesomeIcon icon={faEye} className="" />
    </button>
    <button
      onClick={() => onDownload(row._originalData)}
      className="px-3 py-1.5 bg-blue-50 hover:bg-blue-100  dark:bg-blue-900/30 dark:hover:bg-blue-800/40 text-blue-700 dark:text-blue-400 rounded-lg transition-colors duration-200 flex items-center"
    >
      <FontAwesomeIcon icon={faDownload} className="" />
    </button>
  </motion.div>
);

export default ActionsCell;
